export const getRoles = `
query Role {
  role {
    id
    name
    description
  }
}
`;

export interface GetRolesType {
  role: {
    id: string;
    name: string;
    description?: string;
  }[];
}
